import React from 'react'
import Modal from '../../../ui_reusable/Modal'
import { Button, Message } from 'rsuite'
import useStandardToaster from '../../../ui_reusable/StandardToaster'
import { deleteScenarioReport } from '../../../../api_operations/saveScenarioReport'

const DeleteModal = ({ report, setRefresh, open, onClose }) => {
  const { pushToast } = useStandardToaster()

  const handleSubmit = async () => {
    try {
      const success = await deleteScenarioReport(report.id, pushToast)
      if (success) {
        setRefresh(new Date().getTime())
        onClose()
      }
    } catch (error) {
      console.error(error)
      pushToast(
        <Message type="error">
          {error.message || 'Failed to delete report'}
        </Message>,
        { placement: 'topCenter', duration: 5000 },
      )
    }
  }

  return (
    <Modal open={open} onClose={onClose} title={`Delete ${report.name}`}>
      <Modal.Body>
        <p>
          Are you sure you want to delete this report? This action cannot be
          undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="submit"
          onClick={handleSubmit}
          appearance="primary"
          color="red"
        >
          Delete
        </Button>
        <Button type="submit" onClick={onClose} appearance="subtle">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteModal
